import React, { Component } from 'react';
import { NavLink } from '@minerva-analytics/pantheon';

import { FooterContainer } from './Footer.styles';

export default class Footer extends Component {
  render() {
    return (
      <FooterContainer>
        <span>© 2018 QuizHive</span>
        &nbsp;|&nbsp;
        <NavLink to={ `/privacy` } >
          Privacy Policy
        </NavLink>
        &nbsp;|&nbsp;
        <NavLink to={ `/terms` } >
          Terms & Conditions
        </NavLink>
        &nbsp;|&nbsp;
        <span>617-335-3742</span>
      </FooterContainer>
    );
  }
}
